module.exports = __webpack_public_path__ + "wxMicroService/img/payment1564@2x.7cfa01be.png";